import { Component, Input, OnInit } from '@angular/core';

// Services
import { HelloSignService } from '@app/services/hello-sign.service';
import { MyProfileService } from '@app/services/my-profile.service';

// Models
import { PetStatus } from '@app/models/pet/pet-status.model';

@Component({
  selector: 'app-camper-list',
  templateUrl: './camper-list.component.html',
  styleUrls: ['./camper-list.component.scss'],
})
export class CamperListComponent implements OnInit {
  @Input() showNoRecordText = false;
  @Input() petTileList: PetStatus[];

  constructor(
    private myProfileService: MyProfileService,
    private helloSignService: HelloSignService
  ) {}

  ngOnInit(): void {}

  petImage(i) {
    return `assets/images/Web_dog image_${(i % 4) + 1}.png`;
  }
  get showTermPolicyFormsError(): boolean {
    if (!this.myProfileService.preferredLocation) {
      return false;
    }
    return (
      this.petTileList &&
      this.petTileList.length > 0 &&
      !this.helloSignService.signedTermPolicyForm
    );
  }
}
